import { render, staticRenderFns } from "./CKDialog.vue?vue&type=template&id=0bf97e30&scoped=true&"
import script from "./CKDialog.vue?vue&type=script&lang=js&"
export * from "./CKDialog.vue?vue&type=script&lang=js&"
import style0 from "./CKDialog.vue?vue&type=style&index=0&id=0bf97e30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf97e30",
  null
  
)

export default component.exports